import { render, staticRenderFns } from "./NavigationBreadcrums.vue?vue&type=template&id=6afca6ae"
import script from "./NavigationBreadcrums.vue?vue&type=script&lang=js"
export * from "./NavigationBreadcrums.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports